import { render, staticRenderFns } from "./goodsOverview.vue?vue&type=template&id=0df7f211&scoped=true&"
import script from "./goodsOverview.vue?vue&type=script&lang=js&"
export * from "./goodsOverview.vue?vue&type=script&lang=js&"
import style0 from "./goodsOverview.vue?vue&type=style&index=0&id=0df7f211&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7f211",
  null
  
)

export default component.exports